import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import { config } from "./config";
import { Amplify } from "aws-amplify";
import { AuthProvider } from "./auth/AuthContext";
import { Login } from "./auth/Login";
import "./tailwind.css";
// Configure Amplify using environment variables
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: config.cognito.USER_POOL_ID,
            userPoolClientId: config.cognito.APP_CLIENT_ID,
        },
    },
});
function App() {
    return (_jsx(AuthProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx("div", { children: _jsx(Login, {}) }) }), _jsx(Route, { path: "/home", element: _jsx("div", { children: "Home Page" }) })] }) }));
}
export default App;
